import React from 'react';
import { s } from '../styles';
import { IconSpark, IconFibre } from '../icons';

// Screen 11 — Gentle Push GOOD TO KNOW + WHY IT MATTERS notes. Pairs
// a warm "you can do this" reassurance card with an elevated science
// card so they read as peers, not twins (noteCardElevated lifts the
// second one). Begin CTA launches the push tryout RingPlayer.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <div className="screen-enter-child" style={{ ...s.noteCard, ...s.noteCardWarm }}>
        <div style={s.noteRow}>
          <div style={{ ...s.noteIconDisc, ...s.noteIconDiscWarm }}><IconSpark /></div>
          <span style={{ ...s.noteChip, ...s.noteChipWarm }}>{t('fl_push_goodtoknow_label')}</span>
        </div>
        <h2 style={s.noteTitle}>{t('fl_push_goodtoknow_title')}</h2>
        <p style={s.noteBody}>{t('fl_push_goodtoknow_body')}</p>
      </div>
      <div className="screen-enter-child" style={{ ...s.noteCard, ...s.noteCardElevated }}>
        <div style={s.noteRow}>
          <div style={s.noteIconDisc}><IconFibre /></div>
          <span style={s.noteChip}>{t('fl_push_whymatters_label')}</span>
        </div>
        <h2 style={s.noteTitle}>{t('fl_push_whymatters_title')}</h2>
        <p style={s.noteBody}>{t('fl_push_whymatters_body')}</p>
      </div>
    </div>
  );
}

export function Footer({ t, onBeginTryout }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onBeginTryout}>
      {t('fl_push_cta')}
    </button>
  );
}
